import { useState } from 'react'

import { FlatButton } from 'src/resources/elements/buttons/FlatButton'
import { useModal } from 'src/resources/elements/Modal'
import { Spacing } from 'src/resources/layout'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

const Wrapper = styled.div`
  margin-top: ${Spacing.basePadding4x};

  & > *:first-child {
    margin-right: ${Spacing.basePadding};
  }

  button {
    font-family: inherit !important;
  }
`

interface IEmbedContinueFlow {
  theme: any
  onReset(): Promise<void>
}
export const useEmbedContinueFlow = ({ theme, onReset }: IEmbedContinueFlow) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const embedContinueFlowModal = useModal({
    theme,
    //  This needs to be re-factored somehow to translate here
    header: t('hooks.useEmbedContinueFlow.pickUp'),
    contents: () => (
      <Wrapper style={{ ...(theme?.modalContentStyle ?? {}) }}>
        <FlatButton
          disabled={loading}
          color='primary'
          style={theme?.modalPrimaryButtonStyle}
          onClick={embedContinueFlowModal.close}
        >
          {t('elements.buttons.continue')}
        </FlatButton>
        <FlatButton
          color='secondary'
          variant='empty'
          style={theme?.modalSecondaryButtonStyle}
          disabled={loading}
          onClick={() => {
            setLoading(true)

            onReset()
              .then(() => {
                embedContinueFlowModal.close()
              })
              .catch((e) => {
                console.error(e)
              })
              .finally(() => setLoading(false))
          }}
        >
          {t('elements.buttons.startOver')}
        </FlatButton>
      </Wrapper>
    )
  })

  return {
    open: embedContinueFlowModal.open,
    render: embedContinueFlowModal.render
  }
}
